import { render, staticRenderFns } from "./CaseManagement.vue?vue&type=template&id=c4bbec5a&scoped=true"
import script from "./CaseManagement.vue?vue&type=script&lang=js"
export * from "./CaseManagement.vue?vue&type=script&lang=js"
import style0 from "./CaseManagement.vue?vue&type=style&index=0&id=c4bbec5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bbec5a",
  null
  
)

export default component.exports